// extracted by mini-css-extract-plugin
export var button = "_b-0";
export var buttonContent = "_b-e";
export var buttonGroup = "_b-c";
export var dontRestrainIconWidth = "_b-a";
export var dropdownButton = "_b-b";
export var iconContainer = "_b-9";
export var lg = "_b-4";
export var md = "_b-3";
export var pending = "_b-f";
export var sm = "_b-2";
export var spinner = "_b-d";
export var squared = "_b-8";
export var wrapText = "_b-g";
export var xl = "_b-5";
export var xs = "_b-1";
export var xxl = "_b-6";
export var xxxl = "_b-7";